import mixitup from 'mixitup'
import mixitupMultifilter from './modules/_mixitup-multifilter.js'

mixitup.use(mixitupMultifilter)

function getUrlVars() {
	var vars = []
	var hash
	var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&')

	for (var i = 0; i < hashes.length; i++) {
		hash = hashes[i].split('=')
		vars.push(hash[0])
		vars[hash[0]] = hash[1]
	}

	return vars
}

var filters = getUrlVars()['filters']

if (!filters) {
	filters = 'physician-list-item'
}

$('.fail-message').hide()

mixitup('#filter-container', {
	animation: {
		effects: 'fade scale translateX',
		duration: 500,
	},
	controls: {
		toggleDefault: 'all',
	},
	multifilter: {
		enable: true,
	},
	load: {
		filter: '.' + filters,
	},
	callbacks: {
		onMixFail: function () {
			$('.fail-message').show()
		},
		onMixStart: function () {
			$('.fail-message').removeClass('hide')
			$('.fail-message').hide()
		},
		onMixEnd: function () {
			$('.phys-match').matchHeight({
				byRow: false,
			})
			$('.match-height').matchHeight({
				byRow: false,
			})
			console.log('Success')
		},
	},
})
